module.exports = __webpack_public_path__ + "img/icon-devices-green.770b8cff.svg";